import React from 'react'
import styled from 'styled-components'
import LogoImage from '../../atoms/Utlis/LogoImage'

const Container = styled.div`
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  background: #F8EDFA;
  overflow: hidden;
  width: 100%;
`

const SectionTitle = styled.div`
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 18px;
`

const Paragraph = styled.div`
  margin-bottom: 15px;
`

const List = styled.ul<{ type?: string }>`
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ListItem = styled.li<{ type?: string }>`
  list-style-type: ${({ type }) => (type === 'decimal' ? 'decimal' : 'disc')};
`

const EmailLink = styled.a`
  font-weight: 500;
  cursor: pointer;
  line-height: 28px;
  @media (min-width: 768px) {
    line-height: 33px;
    font-size: 16px;
  }
  font-size: 14px;
  &:hover {
    color: var(--themeColor);
  }
`

const HeaderSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 24px 0;
`

const PrivacyPolicy = () => {
  return (
    <Container>
      <HeaderSection>
        <LogoImage />
      </HeaderSection>

      <Paragraph>
        Welcome to Kwikmedia, operated by Ventureboo LLP. We are committed to protecting your privacy.
        This Privacy Policy outlines how we collect, use, and safeguard your information when you use our app and website.
      </Paragraph>

      <SectionTitle>1. Information We Collect</SectionTitle>
      <List type="decimal">
        <ListItem type="decimal">
          <strong>1.1 Personal Information:</strong> We may collect personal information that you provide to us directly, including but not limited to:
          <List>
            <ListItem>Name</ListItem>
            <ListItem>Email address</ListItem>
            <ListItem>Phone number</ListItem>
            <ListItem>Payment information</ListItem>
            <ListItem>User-generated content (e.g., comments, messages)</ListItem>
          </List>
        </ListItem>
        <ListItem type="decimal">
          <strong>1.2 Usage Data:</strong> We collect information about your interaction with our app and website, such as:
          <List>
            <ListItem>Device information (e.g., device type, operating system)</ListItem>
            <ListItem>IP address</ListItem>
            <ListItem>Browser type and version</ListItem>
            <ListItem>Pages visited and time spent</ListItem>
            <ListItem>App usage data</ListItem>
          </List>
        </ListItem>
        <ListItem type="decimal">
          <strong>1.3 Cookies and Tracking Technologies:</strong> We use cookies and similar technologies to enhance your experience. You can manage cookie preferences through your browser settings.
        </ListItem>
      </List>

      <SectionTitle>2. How We Use Your Information</SectionTitle>
      <Paragraph>We use the information we collect for the following purposes:</Paragraph>
      <List>
        <ListItem>To provide and maintain our services</ListItem>
        <ListItem>To process transactions and manage accounts</ListItem>
        <ListItem>To communicate with you and respond to inquiries</ListItem>
        <ListItem>To personalize your experience and deliver content relevant to your interests</ListItem>
        <ListItem>To improve our app and website functionality</ListItem>
        <ListItem>To comply with legal obligations and protect our rights</ListItem>
      </List>

      <SectionTitle>3. Sharing Your Information</SectionTitle>
      <Paragraph>We do not sell or rent your personal information to third parties. We may share your information with:</Paragraph>
      <List>
        <ListItem>Service providers who assist us in delivering our services</ListItem>
        <ListItem>Legal authorities if required by law or to protect our rights</ListItem>
        <ListItem>Other parties with your consent or as directed by you</ListItem>
      </List>

      <SectionTitle>4. Data Security</SectionTitle>
      <Paragraph>
        We implement industry-standard security measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure.
      </Paragraph>

      <SectionTitle>5. Your Rights</SectionTitle>
      <Paragraph>You have the right to:</Paragraph>
      <List>
        <ListItem>Access and update your personal information</ListItem>
        <ListItem>Request the deletion of your personal information</ListItem>
        <ListItem>Object to the processing of your personal information</ListItem>
        <ListItem>Withdraw consent at any time</ListItem>
      </List>
      <Paragraph>To exercise these rights, please contact us at higcorona@gmail.com.</Paragraph>

      <SectionTitle>6. Third-Party Links</SectionTitle>
      <Paragraph>
        Our app and website may contain links to third-party websites. We are not responsible for the privacy practices of these websites. We encourage you to review their privacy policies.
      </Paragraph>

      <SectionTitle>7. Children's Privacy</SectionTitle>
      <Paragraph>
        Our services are not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware of any such data, we will take steps to delete it.
      </Paragraph>

      <SectionTitle>8. Changes to This Privacy Policy</SectionTitle>
      <Paragraph>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
      </Paragraph>

      <SectionTitle>9. Contact Us</SectionTitle>
      <Paragraph>If you have any questions or concerns about this Privacy Policy, please contact us at:</Paragraph>
      <List>
        <ListItem>
          <strong>Email:</strong>{' '}
          <EmailLink href="mailto:higcorona@gmail.com">higcorona@gmail.com</EmailLink>
        </ListItem>
        <ListItem>
          <strong>Phone:</strong>{' '}
          <EmailLink href="tel:+919099588349">+91 9099588349</EmailLink>
        </ListItem>
      </List>

      <SectionTitle>Important Considerations</SectionTitle>
      <List type="decimal">
        <ListItem type="decimal">
          <strong>Customization:</strong> Tailor the template to reflect the actual practices and data handling procedures of your app and website.
        </ListItem>
        <ListItem type="decimal">
          <strong>Legal Compliance:</strong> Ensure the policy complies with relevant privacy laws, such as GDPR for EU users and CCPA for California residents.
        </ListItem>
        <ListItem type="decimal">
          <strong>Updates:</strong> Regularly review and update the privacy policy to reflect changes in your data practices or legal requirements.
        </ListItem>
        <ListItem type="decimal">
          <strong>Consultation:</strong> It is advisable to consult with a legal professional to ensure the privacy policy is comprehensive and legally sound.
        </ListItem>
      </List>
      <Paragraph>
        This privacy policy will help communicate your commitment to user privacy and build trust with your users by clearly outlining how their data is handled.
      </Paragraph>
    </Container>
  )
}

export default PrivacyPolicy